import SimpleScheduleItem from './SimpleScheduleItem/SimpleScheduleItem';

export default function generateSubComponents(props) {
    return SimpleScheduleItem(props);
}
